<template>
  <div>
    <div class="well well-sm" v-if="!have_corporate">
      <p>Данный клиент не отмечен как корпоративный</p>
      <button class="btn btn-success add-corporate" @click=makeCorp v-if="$store.getters.permCanWrite('billing.client.corporate')" >Сделать клиента корпоративным</button>
    </div>
    <div v-else>
      <form class="form-horizontal">

        <div class="row">
          <div class="col-md-4">
            <GenInput :size=6 :label-size=2 entity=corporate attr=type v-model="model.type" :apiDomain=domain apiTopic=client :apiPath=apiPath />
          </div>      
          <div class="col-md-8">
            <GenInput :size=4 :label-size=2 entity=corporate attr=inn_okpo v-model="model.inn_okpo" :apiDomain=domain apiTopic=client :apiPath=apiPath />
          </div>            
        </div>

        <div class="well">
        <div class="row">
          <div class="col-md-12">
            <GenInput :size=10 :label-size=2 entity=corporate attr=full_name v-model="model.full_name" :apiDomain=domain apiTopic=client :apiPath=apiPath />
          </div>
        </div>
        
        <div class="row">  
          <div class="col-md-8">
            <GenInput :size=8 :label-size=3 entity=corporate attr=location_legal v-model="model.location_legal" name=location_legal :apiDomain=domain apiTopic=client :apiPath=apiPath />
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <GenInput :size=8 :label-size=3 entity=corporate attr=location_actual v-model="model.location_actual" :apiDomain=domain apiTopic=client :apiPath=apiPath />
          </div>
        </div>
        </div>

        <div class="well">
          <GenInput :size=6 :label-size=2 entity=corporate attr=bank_account v-model="model.bank_account" :apiDomain=domain apiTopic=client :apiPath=apiPath />
          <GenInput :size=3 :label-size=2 entity=corporate attr=bank_inn v-model="model.bank_inn" :apiDomain=domain apiTopic=client :apiPath=apiPath />
          <GenInput :size=3 :label-size=2 entity=corporate attr=bank_bik v-model="model.bank_bik" :apiDomain=domain apiTopic=client :apiPath=apiPath />
        </div>
        
        <GenInput :size=10 :label-size=2 entity=corporate attr=service_description v-model="model.service_description"
          :apiDomain=domain apiTopic=client :apiPath=apiPath />
        
        <div v-if="!deleteMode" id="cross-open-delete" class="delete-well">
          <button v-if="$store.getters.permCanWrite('billing.client.corporate')" class="btn btn-light delete-cross"
            @click.prevent="deleteMode = true" title="Удалить корпоративные данные">
              Удалить
          </button>
        </div>

        <div v-else id="user-delete-well" class="delete-well">
          <label class="control-label">Введите uid текущего пользователя</label>

          <input class="form-control input-uid" placeholder="UID" autocomplete="off" v-model="user_uid" maxlength="6"
            :class="{ 'input-error': uidMismatch }" @focus="resetInputError" />

          <button class="btn btn-danger delete-corporate" @click.prevent="deleteCorp">Удалить корпоративные данные</button>
        </div>

      </form>
    </div>
  </div>    
</template>

<script>
import darsan from "darsan"
import sysconf from "sysconf"
import SkelInput from "common/visual/SkelInput.vue"
import GenInput from "common/visual/cooper/GenInput.vue"
import Input from "common/visual/cooper/Input.vue"
import Icon from "common/visual/Icon.vue"

export default {
  
  name: "Corporate",
  
  components: {SkelInput, GenInput},
  
  props: {
    uid: String,
  },
  
  data() {
    return {
      state: {},
      model: {},
      domain: "",
      have_corporate: false,
      deleteMode: false,
      uidMismatch: false,
      corp: {},
    }
  },
  
  async created()
  {
    this.corp = this.$store.getters.entity("client", "corporate")
  },
  
  methods: {
    async load()
    {
      this.have_corporate = false
      this.deleteMode = false

      this.domain = sysconf.domainByUid(this.uid) || config.domain
      
      try {
        this.model = await darsan.getm(this.domain, "client", `/client/${this.uid}/corporate`)
        this.have_corporate = true
      }
      catch(err)
      {
        if (err.status != 404) darsan.err(err)
      }
    },
    
    async makeCorp()
    {
      this.model = await darsan.post(this.domain, "client", `/client/${this.uid}/corporate`)
      this.have_corporate = true
    },

    async resetInputError() {
      this.uidMismatch = false
    },

    async deleteCorp() {
      if (this.uid === this.user_uid) {
        await darsan.delete(this.domain, "client", `/client/${this.uid}/corporate`)
        this.have_corporate = false
        this.deleteMode = false
        this.user_uid = ""
      } else {
        this.uidMismatch = true
      }
    },
  },
  
  computed: {
    apiPath()
    {
      return "/client/"+this.uid+"/corporate"
    },
  },
  
  watch: {
    uid: {
      immediate: true,
      handler(val)
      {
        this.load()
      },
    },
  },
  
}
</script>

<style>
  .delete-well {
    display: flex;
    justify-content: flex-end;
	  align-items: center;
    grid-gap: 10px;
    margin-top: 15px;
  }

  .delete-cross {
    cursor: pointer;
  }

  .input-uid {
    width: 75px;
  }

  .input-error {
    border: 1px solid red;
    box-shadow: 0 0 3px 1px rgba(255, 0, 0, 0.7);
  }
</style>
